module.exports = __webpack_public_path__ + "img/1-1.2f0c4a7c.png";